"use strict";

import decimalFieldDirective from "./decimalfield.component";

const diasFormFields = angular.module("dias.formfields", []);

diasFormFields.directive("diasDecimalField", decimalFieldDirective);

export default diasFormFields;
